module.exports = __webpack_public_path__ + "img/diamond-6.7394e621.png";